export default __webpack_public_path__ + "static/media/SummaryBlue.e5e30b29.svg";